import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allAudio: [],
  singleAudio: null,
  isCreatingAudio: false,
  isDeletingAudio: false,
  isLoadingAllAudio: false,
  isLoadingSingleAudio: false,
  error: null,
};

export const audioSlice = createSlice({
  name: "section",
  initialState,
  reducers: {
    createAudioStart: (state, action) => {
      state.isCreatingAudio = true;
      state.error = null;
    },
    createAudioSuccess: (state, action) => {
      state.isCreatingAudio = false;
    },
    createAudioFailure: (state, action) => {
      state.isCreatingAudio = false;
      state.error = action.payload;
    },
    getAllAudioStart: (state, action) => {
      state.isLoadingAllAudio = true;
      state.error = null;
      state.allSection = [];
    },
    getAllAudioSuccess: (state, action) => {
      state.isLoadingAllAudio = false;
      state.error = null;
      state.allSection = action.payload;
    },
    getAllAudioFailure: (state, action) => {
      state.isLoadingAllAudio = false;
      state.error = action.payload;
      state.allSection = [];
    },
    getAudioStart: (state, action) => {
      state.isLoadingSingleAudio = true;
      state.error = null;
    },
    getAudioSuccess: (state, action) => {
      state.isLoadingSingleAudio = false;
      state.singleAudio = action.payload;
      state.error = null;
    },
    getAudioFailure: (state, action) => {
      state.isLoadingSingleAudio = false;
      state.error = action.payload;
    },
    deleteAudioStart: (state, action) => {
      state.isDeletingAudio = true;
    },
    deleteAudioSuccess: (state, action) => {
      state.isDeletingAudio = false;
    },
    deleteAudioFailure: (state, action) => {
      state.isDeletingAudio = false;
      state.error = action.payload;
    },
  },
});

export const {
  createAudioFailure,
  createAudioStart,
  createAudioSuccess,
  getAllAudioFailure,
  getAllAudioStart,
  getAllAudioSuccess,
  deleteAudioFailure,
  deleteAudioStart,
  deleteAudioSuccess,
  getAudioStart,
  getAudioFailure,
  getAudioSuccess,
} = audioSlice.actions;

const audioReducer = audioSlice.reducer;
export default audioReducer;
